import { EFormState } from '@feathr/blackbox';

export const formStateColorMap: Record<EFormState, string> = {
  [EFormState.Draft]: 'default',
  [EFormState.Published]: 'green',
  [EFormState.Archived]: 'violet',
};
